var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4.00016H19.76C19.2 2.4535 17.7333 1.3335 16 1.3335C14.2667 1.3335 12.8 2.4535 12.24 4.00016H6.66667C5.2 4.00016 4 5.20016 4 6.66683V25.3335C4 26.8002 5.2 28.0002 6.66667 28.0002H25.3333C26.8 28.0002 28 26.8002 28 25.3335V6.66683C28 5.20016 26.8 4.00016 25.3333 4.00016ZM16 3.66683C16.5467 3.66683 17 4.12016 17 4.66683C17 5.2135 16.5467 5.66683 16 5.66683C15.4533 5.66683 15 5.2135 15 4.66683C15 4.12016 15.4533 3.66683 16 3.66683ZM11.8667 22.6668H10C9.62667 22.6668 9.33333 22.3735 9.33333 22.0002V20.0935C9.33333 19.9202 9.4 19.7468 9.53333 19.6268L17.28 11.8802L20.1067 14.7068L12.3333 22.4802C12.2081 22.6009 12.0406 22.6679 11.8667 22.6668ZM22.4667 12.3602L21.0533 13.7735L18.2267 10.9468L19.64 9.5335C19.9067 9.26683 20.32 9.26683 20.5867 9.5335L22.4667 11.4135C22.7333 11.6802 22.7333 12.0935 22.4667 12.3602Z",
    fill: "#1772A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.c9e515c9f606a276fee15e82e1247032.svg";
export { ForwardRef as ReactComponent };